// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 3V0H19V3H16V5H19V8H21V5H24V3H21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20 9.5C20.9002 9.5 21.7499 9.28372 22.5 8.90029V18H6.87574L1.5 22.7038V2H14.8749C14.6329 2.61986 14.5 3.29442 14.5 4C14.5 7.03757 16.9624 9.5 20 9.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-add-filled')
export default class ChatAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-add-filled',
    }
  }
}
